import React from "react";

function Button({ variant = "secondary", size = "md", children, className = "", ...rest }) {
  const classes = ["btn", `btn-${variant}`, `btn-${size}`, className].filter(Boolean).join(" ");
  return (
    <button type="button" className={classes} {...rest}>
      {children}
    </button>
  );
}

export default Button;
